import React from 'react'
import { SpinnerWrapper, SpinnerText } from './styles'
import PropTypes from 'prop-types'

export const Spinner = ({
  loadingText = 'Loading...',
  displaytype = 'flex',
  direction = 'column',
  height = '80px',
  left = '0px',
  bottom = '0px',
  top = '0px',
  right = '0px'
}) => {
  return (
    <SpinnerWrapper display={displaytype} direction={direction} height={height}>
      <SpinnerText tip={loadingText} left={left} top={top} bottom={bottom} right={right} />
    </SpinnerWrapper>
  )
}

Spinner.propTypes = {
  loadingText: PropTypes.string,
  displaytype: PropTypes.string,
  direction: PropTypes.string,
  height: PropTypes.string,
  left: PropTypes.string,
  top: PropTypes.string,
  bottom: PropTypes.string,
  right: PropTypes.string
}
